// removed by extract-text-webpack-plugin
module.exports = {"tiny":"380px","mobile":"768px","medium":"769px","large":"1024px","white":"#ffffff","whiteSmoke":"#f1f1f1","whiteFog":"#f9f9f9","whiteGrey":"#d8d8d8","black":"#000000","grey":"#87848e","lightGrey":"#ccc","primary":"#17479e","secondary":"#17479e","tertiary":"#0097d6","quaternary":"#0c2b77","error":"#e32438","success":"#3885141a","inactive":"#4a4a4a","billPrimary":"#077bc2","linkFocusColor":"#17479e"};


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/directory/GridDirectoryComponent.scss
// module id = 1242
// module chunks = 0